/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { CoreStrictHttpResponse } from '../../core-strict-http-response';
import { CoreRequestBuilder } from '../../core-request-builder';

import { CoreProjectSubtaskResponseDto } from '../../models/core-project-subtask-response-dto';

export interface ProjectSubtasksControllerDelete$Params {

/**
 * The tenant identifier.
 */
  tenant: string;

/**
 * The ID of the project subtask to delete.
 */
  id: string;
}

export function projectSubtasksControllerDelete(http: HttpClient, rootUrl: string, params: ProjectSubtasksControllerDelete$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<CoreProjectSubtaskResponseDto>> {
  const rb = new CoreRequestBuilder(rootUrl, projectSubtasksControllerDelete.PATH, 'delete');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as CoreStrictHttpResponse<CoreProjectSubtaskResponseDto>;
    })
  );
}

projectSubtasksControllerDelete.PATH = '/o2-core/project-subtasks/{tenant}/{id}';
